/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Qbank_Seniority_SeniorInputs */

const en_interview_qbank_seniority_senior = /** @type {(inputs: Interview_Qbank_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior`)
};

const de_interview_qbank_seniority_senior = /** @type {(inputs: Interview_Qbank_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior`)
};

const fr_interview_qbank_seniority_senior = /** @type {(inputs: Interview_Qbank_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior`)
};

const es_interview_qbank_seniority_senior = /** @type {(inputs: Interview_Qbank_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior`)
};

const it_interview_qbank_seniority_senior = /** @type {(inputs: Interview_Qbank_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior`)
};

const nl_interview_qbank_seniority_senior = /** @type {(inputs: Interview_Qbank_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior`)
};

const pl_interview_qbank_seniority_senior = /** @type {(inputs: Interview_Qbank_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior`)
};

const fi_interview_qbank_seniority_senior = /** @type {(inputs: Interview_Qbank_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seniori`)
};

const da_interview_qbank_seniority_senior = /** @type {(inputs: Interview_Qbank_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior`)
};

const sv_interview_qbank_seniority_senior = /** @type {(inputs: Interview_Qbank_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior`)
};

/**
* | output |
* | --- |
* | "Senior" |
*
* @param {Interview_Qbank_Seniority_SeniorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_qbank_seniority_senior = /** @type {((inputs?: Interview_Qbank_Seniority_SeniorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Qbank_Seniority_SeniorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_qbank_seniority_senior(inputs)
	if (locale === "fr") return fr_interview_qbank_seniority_senior(inputs)
	if (locale === "es") return es_interview_qbank_seniority_senior(inputs)
	if (locale === "it") return it_interview_qbank_seniority_senior(inputs)
	if (locale === "nl") return nl_interview_qbank_seniority_senior(inputs)
	if (locale === "pl") return pl_interview_qbank_seniority_senior(inputs)
	if (locale === "fi") return fi_interview_qbank_seniority_senior(inputs)
	if (locale === "da") return da_interview_qbank_seniority_senior(inputs)
	if (locale === "sv") return sv_interview_qbank_seniority_senior(inputs)
	return en_interview_qbank_seniority_senior(inputs)
});